import { GuiasService } from './../../services/guias/guias.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl} from '@angular/forms';
import { EmpresasService } from '../../services/empresas/empresas.service';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';
import { Router } from '@angular/router';
import Swal from "sweetalert2";
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesGeneral, MessagesStatus } from '../../models/messages';

@Component({
    selector: 'app-adjuntar-logo',
    templateUrl: './adjuntar-logo.component.html',
    styleUrls: ['./adjuntar-logo.component.scss'],
    providers:[
      SafeUrlPipe,MessagesTitles,MessagesGeneral,MessagesStatus
    ]
})

export class AdjuntarLogoComponent implements OnInit {

    @Input() dataEmpresa : any=[];
    @Output() cerrarPopUp: EventEmitter<boolean>;
    @Output() refresh = new EventEmitter<boolean>();
    form : FormGroup;
    user:any;
    files: any[] = [];
    dataEnviar:any={};
    filesB64 :any;
    cantItems:number;
    arrayRepetidos: any = [];
    arrayAdjuntos:any = [];
    loading:boolean;
    view:boolean;

    Codigo:any= 1;
    TipoAdjunto:any = [];
    CantidadItems:number = 1;
    constructor(private router:Router ,
        private msgTitle :MessagesTitles,
        private msgStatus:MessagesStatus,
        private empresasService : EmpresasService,
        private guiasService:GuiasService){
        
        this.user = JSON.parse(sessionStorage.getItem('UserActive'));
        this.cerrarPopUp = new EventEmitter();
    }

    ngOnInit(){
      this.form = new FormGroup({
          idEmpresa : new FormControl({ value: "", disabled: true }),
          file_content : new FormControl({ disabled: true }),
          Usuario : new FormControl({ value: "", disabled: true }),
          Razon_Social : new FormControl({ value: "", disabled: true }),
          Num_Doc_Identificacion : new FormControl({ value: "", disabled: true }),
          file_empresa : new FormControl({ value: "", disabled: false }),
          Estado : new FormControl({ value: "", disabled: true }),
          Descripcion:new FormControl({value:"",disabled:false}),
      })
    }

    Guardar(){
      

        this.cantItems = this.files.length - 1;
         let i = 0;
         this.dataEnviar.Usuario = this.user.Usuario;
         this.dataEnviar.idEmpresa = this.dataEmpresa.idEmpresa
         this.dataEnviar.Descripcion = this.form.controls['Descripcion'].value;
         for( let p of this.files){
           
            if(p.type != 'image/png'){
              Swal.fire({
                title: this.msgTitle.Error,
                text: 'El archivo '+ p.name+ ' no es una imagen',
                type: "warning",
                allowOutsideClick: false,
                heightAuto: false
              });
             return;
           }
    
          this.aBinario(this.files,i)
          i++;
            
            }
        
      }
    
    aBinario(fileList: any ,index:any){
        let file = fileList[index];
        let fileReader: FileReader = new FileReader();
        var base64;
        var archivo64;
        var self = this;
        fileReader.onload =  function(fileLoadedEvent) {
                  base64 = fileLoadedEvent.target['result'];
                  archivo64 = base64.split(',',2);
                  self.filesB64 = archivo64[1];
    
                  self.dataEnviar.file_content = self.filesB64;
                  self.dataEnviar.file_type = file.type;
                  if(self.cantItems == index){
                    self.Enviar(self.dataEnviar)
                  }
               };
               
        fileReader.readAsDataURL(file);
      
      }

      Enviar(dataEnviar:any){
        Swal.fire({
          title: "Espere",
          text: "Guardando Archivo",
          type: "info",
          allowOutsideClick: false,
          heightAuto: false
      });
      Swal.showLoading();
      
      this.empresasService.guardarLogo(dataEnviar)
      .subscribe(
        res=>{
          Swal.fire({
            title: "Success",
            text: "Archivo registrado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp => {
            if (resp.value){
              this.cerrarPopUp.emit();
              this.refresh.emit();
            }
          });
        },(err: HttpErrorResponse)=> {
          if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
        Swal.fire({
          title: this.msgTitle.Error,
          text: "ARCHIVO NO GUARDADO. "+this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
        }
      );
      }

    /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {

      if (files.length > this.CantidadItems || files.length+this.files.length > this.CantidadItems) {
        Swal.fire({
          title: this.msgTitle.Error,
          text: 'Máximo '+ this.CantidadItems+ ' archivo',
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
        return
      }
      if (this.files.length > this.CantidadItems) {
        Swal.fire({
          title: this.msgTitle.Error,
          text: 'Máximo '+ this.CantidadItems+ ' archivo',
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
        return
      }

    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }



    CerrarVentana(){
        this.cerrarPopUp.emit();
    }
}